var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.authViewState === "forgotPassword"
    ? _c("forgot-password")
    : _vm.authViewState === "signUp"
    ? _c("sign-up")
    : _c("sign-in")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }